import { createContext, useContext, useState } from 'react';

interface IZerezesGlobalState {
  globalState?: {
    get: (name: string) => any;
    set: (name: string, value: any) => void;
  }
}

const ZerezesGlobalStateContext = createContext<IZerezesGlobalState>({});

const ZerezesGlobalStateProvider = (props: any) => {

  const { children } = props;
  const [globalState, setGlobalState] = useState<any>({});

  const value: IZerezesGlobalState = {
    globalState: {
      get: (name: string) => globalState[name],
      set: (name: string, value: any) => {
        const newGlobalState = { ...globalState };
        newGlobalState[name] = value;
        console.log('new global state:', newGlobalState);
        setGlobalState(newGlobalState);
      }
    }
  }

  return (
    <ZerezesGlobalStateContext.Provider value={value}>
      {children}
    </ZerezesGlobalStateContext.Provider>
  )
}

const useZerezesGlobalState = () => {
  const context = useContext(ZerezesGlobalStateContext);
  return context;
}

export { ZerezesGlobalStateProvider, useZerezesGlobalState };